module.exports = __webpack_public_path__ + "static/media/uddemypy.a4ae2206.jpg";